import { DOMAIN } from "../env";

// https://api.countapi.xyz/[:get/:hit]/[:domain]/[:namespace]
const providerURL = `https://api.countapi.xyz`;
const getEndpoint = (namespace, type = "get") =>
  `${providerURL}/${type}/${DOMAIN}/${namespace}`;

export const fetchUrl = url =>
  fetch(url)
    .then(response => response.json())
    .then(json => json.value);

// invaders / visitors + tracker
export const getInvaders = () => fetchUrl(getEndpoint("invaders"));
export const followTheWhiteRabbit = () =>
  fetchUrl(getEndpoint("invaders", "hit"));

// spooners / humans + click tracker
export const getSpooners = () => fetchUrl(getEndpoint("spooners"));
export const thereIsNoSpoon = () => fetchUrl(getEndpoint("spooners", "hit"));
